<template>
  <div class="row restaurant-home-statistic bg-secondary rounded-2 bg-opacity-10 mx-1 my-3">
    <h4 class="pt-3 px-3 mb-0">{{ $t('homeStatistics.title') }} <b>{{ this.rest['title'] }}</b>
      <div v-show="this.STATISTICS_LOADING" class="ms-2 spinner-border spinner-border-sm h4 fw-normal text-success" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </h4>
    <span class="pb-3 px-3 small text-muted">{{ $t('homeStatistics.lastDay') }} ({{ timeForStatistic(this.stat.start_date) }} - {{ timeForStatistic(this.stat.end_date) }})</span>
    <div class="col-12 col-md-6 col-xl-3 mb-3"
         :class="this.STATISTICS_LOADING ? 'opacity-50' : ''">
      <div class="p-2 bg-white rounded-2 border border-secondary border-opacity-50 h-100 flex-column d-flex justify-content-between">
        <h5 class="mb-3 text-center">{{ $t('homeStatistics.orders.title') }}</h5>
        <div class="progress mb-2" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
          <div class="progress-bar bg-success"
               :style="styleWidthComplete">{{this.stat['completed_orders_percentage_of_all_orders']}}%</div>
          <div v-if="this.stat['number_of_all_orders'] === 0"
               class="progress-bar bg-info"
               style="width: 100%">0</div>
          <div v-else class="progress-bar bg-danger"
               :style="styleWidthCancelled">{{100 - this.stat['completed_orders_percentage_of_all_orders']}}%</div>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div>
            <span class="badge bg-info small text-info"> .</span> {{ $t('homeStatistics.orders.all') }}
          </div>
          <div> {{this.stat['number_of_all_orders']}} </div>
          <!--            {{this.stat['']}}   -->
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div>
            <span class="badge bg-success small text-success"> .</span> {{ $t('homeStatistics.orders.completed') }}
          </div>
          <div> {{this.stat['number_of_completed_orders_all']}} </div>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div>
            <span class="badge bg-danger small text-danger"> .</span> {{ $t('homeStatistics.orders.cancelled') }}
          </div>
          <div>
            {{this.stat['number_of_cancelled_orders_all']}}
          </div>
        </div>
        <p class="small text-muted text-end mb-0">{{ $t('homeStatistics.orders.help') }}</p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3 mb-3"
         :class="this.STATISTICS_LOADING ? 'opacity-50' : ''">
      <div class="p-2 bg-white rounded-2 border border-secondary border-opacity-50 h-100 flex-column d-flex justify-content-between">
        <h5 class="mb-3 text-center">{{ $t('homeStatistics.completedOrders.title') }}</h5>
        <div class="d-flex justify-content-around align-items-center">
          <div class="text-center">
            <svg class="bi fs-4 delete-product-ico" width="2.1rem" height="2.1rem" fill="rgb(14,202,240)">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#truck"/>
            </svg>
            <p class="small mb-0 text-muted">{{ $t('homeStatistics.completedOrders.delivery') }}</p>
            <p class="fs-5 mb-0">{{this.stat['number_of_completed_orders_delivery']}}</p>
          </div>
          <div class="text-center">
            <svg class="bi fs-4 delete-product-ico" width="2rem" height="2rem" fill="orange">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#person-square"/>
            </svg>
            <p class="small mb-0 text-muted">{{ $t('homeStatistics.completedOrders.takeAway') }}</p>
            <p class="fs-5 mb-0">{{this.stat['number_of_completed_orders_takeaway']}}</p>
          </div>
        </div>
        <p class="small text-muted text-end mb-0"></p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3 mb-3"
         :class="this.STATISTICS_LOADING ? 'opacity-50' : ''">
      <div class="p-2 bg-white rounded-2 border border-secondary border-opacity-50 h-100 flex-column d-flex justify-content-between">
        <h5 class="mb-3 text-center ">{{ $t('homeStatistics.sum.title') }}</h5>
        <div class="d-flex justify-content-around align-items-center">
          <div class="text-center">
            <svg class="bi fs-4 delete-product-ico" width="2rem" height="2rem" fill="green">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#receipt-cutoff"/>
            </svg>
            <p class="small mb-0 text-muted">{{ $t('homeStatistics.sum.amount') }}</p>
            <p class="fs-5 mb-0">{{this.stat['completed_orders_amount_all']}} {{ $t('homeStatistics.sum.currency') }}</p>
          </div>
          <div class="text-center">
            <svg class="bi fs-4 delete-product-ico" width="2rem" height="2rem" fill="gray">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#receipt-cutoff"/>
            </svg>
            <p class="small mb-0 text-muted">{{ $t('homeStatistics.sum.average') }}</p>
            <p class="fs-5 mb-0">{{this.stat['completed_orders_average_all']}} {{ $t('homeStatistics.sum.currency') }}</p>
          </div>
        </div>
        <p class="small text-muted text-end mb-0">{{ $t('homeStatistics.sum.help') }}</p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3 mb-3"
         :class="this.STATISTICS_LOADING ? 'opacity-50' : ''">
      <div class="p-2 bg-white rounded-2 border border-secondary border-opacity-50 h-100">
        <h5 class="mb-3 text-center ">{{ $t('homeStatistics.info.title') }}</h5>
        <table class="table">
          <tbody>
          <tr v-if="this.rest['is_available']">
            <td>{{ $t('homeStatistics.info.isAvailable') }}</td>
            <td><svg class="bi fs-4 mb-1" width="1rem" height="1rem" fill="green">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#check-square-fill"/>
            </svg> {{ $t('homeStatistics.info.yes') }}</td>
          </tr>
          <tr v-else>
            <td>{{ $t('homeStatistics.info.isAvailable') }}</td>
            <td><svg class="bi fs-4 mb-1" width="1rem" height="1rem" fill="rgb(220,53,69)">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#x-square-fill"/>
            </svg> {{ $t('homeStatistics.info.no') }}</td>
          </tr>
          <tr v-if="this.rest['is_open']">
            <td>{{ $t('homeStatistics.info.isOpen') }}</td>
            <td><svg class="bi fs-4 mb-1" width="1rem" height="1rem" fill="green">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#check-square-fill"/>
            </svg> {{ $t('homeStatistics.info.yes') }}</td>
          </tr>
          <tr v-else>
            <td>{{ $t('homeStatistics.info.isOpen') }}</td>
            <td><svg class="bi fs-4 mb-1" width="1rem" height="1rem" fill="rgb(220,53,69)">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#x-square-fill"/>
            </svg> {{ $t('homeStatistics.info.no') }}</td>
          </tr>
          </tbody>
        </table>
        <div class="text-end">
          <button class="btn btn-sm btn-success"
          @click="openStatistic()">
            {{ $t('homeStatistics.info.allStatistics') }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {mapGetters} from "vuex";
import router from "@/router";

export default {
  props: ['rest',],
  name: "HomeStatistics",
  data() {
    return {
      stat: {
        start_date: '2020-01-01T00:00:00+02:00',
        end_date: '2020-01-01T00:00:00+02:00',
        cancelled_orders_amount_all: 0,
        cancelled_orders_amount_delivery: 0,
        cancelled_orders_amount_takeaway: 0,
        cancelled_orders_average_all: 0,
        cancelled_orders_average_delivery: 0,
        cancelled_orders_average_takeaway: 0,
        completed_orders_amount_all: 0,
        completed_orders_amount_delivery: 0,
        completed_orders_amount_takeaway: 0,
        completed_orders_average_all: 0,
        completed_orders_average_delivery: 0,
        completed_orders_average_takeaway: 0,
        delivery_orders_percentage_of_completed_orders: 0,
        completed_orders_percentage_of_all_orders: 0,
        number_of_all_orders: 0,
        number_of_cancelled_orders_all: 0,
        number_of_cancelled_orders_delivery: 0,
        number_of_cancelled_orders_takeaway: 0,
        number_of_completed_orders_all: 0,
        number_of_completed_orders_delivery: 0,
        number_of_completed_orders_takeaway: 0,
        number_of_orders_in_progress: 0,
        takeaway_orders_percentage_of_completed_orders: 0,
      }
    }
  },
  computed: {
    ...mapGetters([
      'RESTAURANTS',
      'STATISTICS',
      'STATISTICS_LOADING',
    ]),
    styleWidthComplete() {
      let num = this.stat['completed_orders_percentage_of_all_orders']
      return `width: ${num}%`
    },
    styleWidthCancelled() {
      let num = 100 - this.stat['completed_orders_percentage_of_all_orders']
      return `width: ${num}%`
    }
  },
  methods: {
    timeForStatistic(time) {
      let date = new Date(time)
      let options = {
        era: undefined,
        year: undefined,
        month: '2-digit',
        day: '2-digit',
        weekday: undefined,
        timezone: 'UTC',
        hour: 'numeric',
        minute: 'numeric',
        second: undefined
      };
      return date.toLocaleString("ru", options)
    },
    openStatistic() {
      this.$store.commit('setSelectedRestaurant', this.rest.id)
      router.push({ name: 'Statistics' })
    }
  },
  mounted() {
    let restId = this.rest.id
    const start = async () => {
      await this.$store.dispatch('getStatistics', restId);
    }
    start().then( () => {
      this.stat = this.STATISTICS[restId]
    })
  },
}
</script>

<style scoped>

</style>